/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDto } from './ContactDto';
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
    ContactDtoToJSONTyped,
} from './ContactDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ContactsResponseDto
 */
export interface ContactsResponseDto {
    /**
     * List of contacts
     * @type {Array<ContactDto>}
     * @memberof ContactsResponseDto
     */
    contacts: Array<ContactDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof ContactsResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the ContactsResponseDto interface.
 */
export function instanceOfContactsResponseDto(value: object): value is ContactsResponseDto {
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ContactsResponseDtoFromJSON(json: any): ContactsResponseDto {
    return ContactsResponseDtoFromJSONTyped(json, false);
}

export function ContactsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(ContactDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function ContactsResponseDtoToJSON(json: any): ContactsResponseDto {
    return ContactsResponseDtoToJSONTyped(json, false);
}

export function ContactsResponseDtoToJSONTyped(value?: ContactsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(ContactDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

